import React from 'react';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { useSelector } from 'react-redux';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import BankTransferDialog from './BankTransferDialog';
import BankTransferDialogV2 from './BankTransferDialogV2';

const BankTransferDialogContainer = (props) => {
  const { getFeatureValue } = useFeatureFlags();
  const user = useSelector((state) => state.auth.user);
  const usePaymentQRV2 = getFeatureValue(FEATURE_KEYS.PAYMENT_QR_V2, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  return usePaymentQRV2 ? (
    <BankTransferDialogV2 {...props} />
  ) : (
    <BankTransferDialog {...props} />
  );
};

export default BankTransferDialogContainer;
